import React, { useEffect } from 'react'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { CmsContentWrap } from './components/Styled'

interface CmsBlockData {
  id: string
  updatedAt?: number
  content: string
  isSuccess: boolean
  isFailure: boolean
  isFirstLoad: boolean
}

export const Faq =() => {
  const staticBlock = useCmsBlock({
    id: CMS_BLOCK.FAQ,
    isLazy: false

  }) as CmsBlockData

  useEffect(() => {
    const hash = window.location.hash
    if (hash) {
      document.querySelector(hash)?.scrollIntoView()
    }
  }, [staticBlock])

  return (
    <CmsContentWrap>
      {staticBlock.content && (
        <div
          dangerouslySetInnerHTML={{
            __html: staticBlock?.content ?? ''
          }}
        />
      )}
    </CmsContentWrap>
  )
}
